module.exports = __webpack_public_path__ + "img/club_cerro_porteno.f3c1ddb5.png";